import { Component } from "@theme/component";
import { PaginatedListAspectRatioHelper } from "@theme/paginated-list-aspect-ratio";

/**
 * Base for list sections (blog, collection results). The theme uses link pagination only;
 * infinite-scroll “view more” refs are not used.
 *
 * Subclasses: {@link BlogPostsList}, {@link ResultsList}.
 *
 * @typedef {object} Refs
 * @property {HTMLElement} [grid] - Used by subclasses (e.g. results-list layout).
 * @property {HTMLElement[]} [cards] - Optional; reserved for list items.
 *
 * @extends Component<Refs>
 */
export default class PaginatedList extends Component {
  connectedCallback() {
    super.connectedCallback();

    const templateCard = this.querySelector('[ref="cardGallery"]');
    if (templateCard) {
      new PaginatedListAspectRatioHelper({ templateCard });
    }
  }

  get sectionId() {
    const id = this.getAttribute("section-id");

    if (!id) throw new Error("The section-id attribute is required");

    return id;
  }
}
